import {
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowRight,
  ArrowUpDown,
  BadgePercent,
  Banknote,
  Building2,
  Calendar,
  CalendarOff,
  CarFront,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleHelp,
  CircleUser,
  CircleUserRound,
  CreditCard,
  Drama,
  Ellipsis,
  EvCharger,
  FileText,
  Filter,
  Grid3x3,
  HandCoins,
  Handshake,
  HelpCircle,
  Info,
  KeyRound,
  Loader2,
  LoaderCircle,
  LockOpen,
  LogOut,
  Map,
  MapPin,
  Menu,
  Minus,
  Moon,
  MoreHorizontal,
  PanelLeftClose,
  PanelLeftOpen,
  Plus,
  Plug,
  Search,
  Settings,
  Smartphone,
  SquarePen,
  Sun,
  Trash2,
  UserPen,
  Users,
  X,
  Zap,
  type LucideIcon,
} from "lucide-react";

export type IconName =
  | "activity"
  | "alertCircle"
  | "alertTriangle"
  | "arrowRight"
  | "arrowUpDown"
  | "badgePercent"
  | "banknote"
  | "building2"
  | "calendar"
  | "calendarOff"
  | "carFront"
  | "check"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "circleCheck"
  | "circleHelp"
  | "circleUser"
  | "circleUserRound"
  | "creditCard"
  | "drama"
  | "ellipsis"
  | "evCharger"
  | "fileText"
  | "filter"
  | "grid"
  | "handCoins"
  | "handshake"
  | "helpCircle"
  | "info"
  | "keyRound"
  | "loader"
  | "loaderCircle"
  | "lockOpen"
  | "logOut"
  | "map"
  | "mapPin"
  | "menu"
  | "minus"
  | "moon"
  | "moreHorizontal"
  | "panelLeftClose"
  | "panelLeftOpen"
  | "plus"
  | "plug"
  | "search"
  | "settings"
  | "smartphone"
  | "squarePen"
  | "sun"
  | "trash"
  | "userPen"
  | "users"
  | "x"
  | "zap";

export const iconMap: Record<IconName, LucideIcon> = {
  activity: Activity,
  alertCircle: AlertCircle,
  alertTriangle: AlertTriangle,
  arrowRight: ArrowRight,
  arrowUpDown: ArrowUpDown,
  badgePercent: BadgePercent,
  banknote: Banknote,
  building2: Building2,
  calendar: Calendar,
  calendarOff: CalendarOff,
  carFront: CarFront,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  circleCheck: CircleCheck,
  circleHelp: CircleHelp,
  circleUser: CircleUser,
  circleUserRound: CircleUserRound,
  creditCard: CreditCard,
  drama: Drama,
  ellipsis: Ellipsis,
  evCharger: EvCharger,
  fileText: FileText,
  filter: Filter,
  grid: Grid3x3,
  handCoins: HandCoins,
  handshake: Handshake,
  helpCircle: HelpCircle,
  info: Info,
  keyRound: KeyRound,
  loader: Loader2,
  loaderCircle: LoaderCircle,
  lockOpen: LockOpen,
  logOut: LogOut,
  map: Map,
  mapPin: MapPin,
  menu: Menu,
  minus: Minus,
  moon: Moon,
  moreHorizontal: MoreHorizontal,
  panelLeftClose: PanelLeftClose,
  panelLeftOpen: PanelLeftOpen,
  plus: Plus,
  plug: Plug,
  search: Search,
  settings: Settings,
  smartphone: Smartphone,
  squarePen: SquarePen,
  sun: Sun,
  trash: Trash2,
  userPen: UserPen,
  users: Users,
  x: X,
  zap: Zap,
} as const;
